import React, { useState } from 'react';
import axiosInstance from '../../../services/api/axiosInstance';
import { getAccountId, saveAccount } from '../../utils/savedAccounts';
import Modal from '../modal/Modal';

const fieldStyle = { width: '100%', minHeight: 44, padding: '8px 12px', border: '1px solid #cbd5e1', borderRadius: 10, fontSize: 16 };

export const AddProfileModal = ({ isOpen, onClose, onAdded }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const close = () => {
    setUsername('');
    setPassword('');
    setError('');
    onClose();
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError('Username and password are required');
      return;
    }
    setLoading(true);
    setError('');
    try {
      // Verifies the credentials only; the current session is left untouched until the user switches.
      const response = await axiosInstance.post('/auth/login', { username, password });
      if (!response?.data?.success) {
        setError(response?.data?.message || 'Could not add this profile.');
        return;
      }
      const { data, token } = response.data;
      saveAccount(data, token);
      const id = getAccountId(data);
      close();
      onAdded(id);
    } catch (err) {
      setError(err?.response?.data?.message || 'Could not add this profile. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show title="Add another profile" onClose={close} showCloseButton={false} width="380px" size="xs" isLock={false}>
      <form
        onSubmit={submit}
        style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
      >
        <p style={{ margin: 0, fontSize: 13, color: '#64748b' }}>
          Enter the child's login. You stay signed in until you switch.
        </p>
        {error && <div role="alert" style={{ color: '#dc2626', fontSize: 13 }}>{error}</div>}
        <input
          style={fieldStyle}
          placeholder="Username"
          autoComplete="username"
          autoFocus
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          style={fieldStyle}
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" onClick={close} className="btn btn-light" style={{ flex: 1, minHeight: 44 }}>Cancel</button>
          <button type="submit" disabled={loading} className="btn btn-primary" style={{ flex: 1, minHeight: 44 }}>
            {loading ? 'Adding...' : 'Add & switch'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddProfileModal;
